// Keep in sync with HIVED_EMAIL_DOMAIN in
// supabase/functions/_shared/constants/hived.ts
const HIVED_EMAIL_DOMAIN = "@hived.space"

export function isHivedEmail(email: string): boolean {
  return email.trim().toLowerCase().endsWith(HIVED_EMAIL_DOMAIN)
}
